import {
  FETCH_PROFILE_INFO,
  FETCH_PROFILE_INFO_SUCCESS,
  RESET,
  FETCH_GAME_INFO,
  FETCH_PROFILE_INFO_FAILED,
  FETCH_GAME_INFO_FAILED,
  FETCH_GAME_INFO_SUCCESS,
  LEAVE_GAME_SUCCESS
} from "./types";
import { auth, database } from "../../App";
import { gameActionInterface } from "../reducers/GameReducers";
import { Dispatch } from "react";
import { profileActionInterface } from "../reducers/ProfileReducers";

export const fetchProfileInfo = () => (
  dispatch: Dispatch<gameActionInterface | profileActionInterface>
) => {
  const { currentUser } = auth;
  if (currentUser) {
    dispatch({ type: FETCH_PROFILE_INFO });
    database
      .ref("users")
      .child(currentUser.uid)
      .child("profile")
      .on("value", profileSnap => {
        if (profileSnap.val()) {
          dispatch({
            type: FETCH_PROFILE_INFO_SUCCESS,
            payload: profileSnap.val()
          });
          if (profileSnap.val().gameId) {
            dispatch({ type: FETCH_GAME_INFO });
            database
              .ref("games")
              .child("created")
              .child(profileSnap.val().gameId)
              // be aware of this change -> once -> on
              .on("value", createdGameSnap => {
                if (createdGameSnap.val()) {
                  return dispatch({
                    type: FETCH_GAME_INFO_SUCCESS,
                    payload: createdGameSnap.val()
                  });
                } else {
                  database
                    .ref("games")
                    .child("playing")
                    .child(profileSnap.val().gameId)
                    // be aware of this change -> once -> on
                    .on("value", playingGameSnap => {
                      if (playingGameSnap.val()) {
                        return dispatch({
                          type: FETCH_GAME_INFO_SUCCESS,
                          payload: playingGameSnap.val()
                        });
                      } else {
                        database
                          .ref("users")
                          .child(currentUser.uid)
                          .child("profile")
                          .update({ gameId: null });
                        return dispatch({
                          type: FETCH_GAME_INFO_FAILED
                        });
                      }
                    });
                  database
                    .ref("users")
                    .child(currentUser.uid)
                    .child("profile")
                    .update({ gameId: null });
                  return dispatch({
                    type: FETCH_GAME_INFO_FAILED
                  });
                }
              });
          } else {
            return dispatch({ type: LEAVE_GAME_SUCCESS });
          }
        } else {
          return dispatch({
            type: FETCH_PROFILE_INFO_FAILED
          });
        }
      });
  }
};

export const resetStates = () => {
  return (dispatch: any) => {
    dispatch({ type: RESET });
  };
};
